/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { SearchIndex } from '../model/searchIndex';
import { SearchIndexCreateRequest } from '../model/searchIndexCreateRequest';
import { SearchIndexKeys } from '../model/searchIndexKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class SearchIndexService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createSearchIndex
     * Creates a new search index.
     * @param searchIndexCreateRequest the information needed to create a search index
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchIndexCreateSearchIndex(searchIndexCreateRequest: SearchIndexCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<SearchIndex>;
    public searchIndexCreateSearchIndex(searchIndexCreateRequest: SearchIndexCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchIndex>>;
    public searchIndexCreateSearchIndex(searchIndexCreateRequest: SearchIndexCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchIndex>>;
    public searchIndexCreateSearchIndex(searchIndexCreateRequest: SearchIndexCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (searchIndexCreateRequest === null || searchIndexCreateRequest === undefined) {
            throw new Error('Required parameter searchIndexCreateRequest was null or undefined when calling searchIndexCreateSearchIndex.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SearchIndex>(`${this.configuration.basePath}/searchIndexes`,
            searchIndexCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteSearchIndex
     * Deletes an existing search index by its name.
     * @param searchIndexName the search index name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchIndexDeleteSearchIndex(searchIndexName: string, observe?: 'body', reportProgress?: boolean): Observable<SearchIndex>;
    public searchIndexDeleteSearchIndex(searchIndexName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchIndex>>;
    public searchIndexDeleteSearchIndex(searchIndexName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchIndex>>;
    public searchIndexDeleteSearchIndex(searchIndexName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (searchIndexName === null || searchIndexName === undefined) {
            throw new Error('Required parameter searchIndexName was null or undefined when calling searchIndexDeleteSearchIndex.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<SearchIndex>(`${this.configuration.basePath}/searchIndexes/${encodeURIComponent(String(searchIndexName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSearchIndex
     * Gets an existing search index by its name.
     * @param searchIndexName the name of the search index
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchIndexGetSearchIndex(searchIndexName: string, observe?: 'body', reportProgress?: boolean): Observable<SearchIndex>;
    public searchIndexGetSearchIndex(searchIndexName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchIndex>>;
    public searchIndexGetSearchIndex(searchIndexName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchIndex>>;
    public searchIndexGetSearchIndex(searchIndexName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (searchIndexName === null || searchIndexName === undefined) {
            throw new Error('Required parameter searchIndexName was null or undefined when calling searchIndexGetSearchIndex.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SearchIndex>(`${this.configuration.basePath}/searchIndexes/${encodeURIComponent(String(searchIndexName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSearchIndexes
     * Gets a list of search index keys for all search indexes defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchIndexGetSearchIndexes(observe?: 'body', reportProgress?: boolean): Observable<SearchIndexKeys>;
    public searchIndexGetSearchIndexes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchIndexKeys>>;
    public searchIndexGetSearchIndexes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchIndexKeys>>;
    public searchIndexGetSearchIndexes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SearchIndexKeys>(`${this.configuration.basePath}/searchIndexes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
